import styled from 'styled-components'
import {Link as LinkR} from 'react-router-dom'
import {Link as LinkS} from 'react-scroll'

export const Nav = styled.nav`
  background: ${({ scrollNav, isHomePage }) =>
    isHomePage
      ? (scrollNav ? 'rgba(0, 0, 0, 0.7)' : 'transparent')
      : '#262B40'};

  height: 60px;
  margin-top: ${({ isHomePage }) => (isHomePage ? '-60px' : '0')};
  display: flex;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
  transition: all 0.3s ease-in-out;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavbarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between; /* Divides into three parts */
    width: 100%;
    height: 100%; /* Ensure full height for the container */
    padding: 0 20px;
     @media screen and (max-width: 768px) {
       padding: 0 10px;
    }
 @media screen and (max-width: 300px) {
    padding:  0 5px; 
  

  }
`;

export const NavLeft = styled.div`
    display: flex;
    align-items: center;
 
`;

export const NavCenter = styled.ul`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1; 
    height: 100%;
`;



export const NavLogo = styled(LinkR)`
    //color: #8BC34A;
    color: #fff;
    justify-self: flex-start;
    cursor: pointer;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    font-weight: bold;
    text-decoration: none;
    transition: all ease 0.2s;

    &:hover {
        color: #8BC34A;
    }
         @media screen and (max-width: 768px) {
        font-size: 1.2rem; 
        
    }

    @media screen and (max-width: 300px) {
        font-size: 1rem; 
       
    }

`

export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 768px) {
        display: block;
        position: absolute;
        top: 50%;
        right: 10px; /* Adjust right position for better spacing */
        transform: translateY(-50%); /* Ensure it is vertically centered */
        font-size: 1.8rem;
        cursor: pointer;
        color: #fff;
        z-index: 10; /* Ensure it stays above other elements */
    }
         @media screen and (max-width: 300px) {
       font-size: 1.2rem;
  

  }
`;


export const NavMenu = styled.div`
    display: flex;
    align-items: center;
    justify-content: center; 
    list-style: none;
    height: 100%; /* Fix: Ensures full height */
    flex-grow: 1;

    @media screen and (max-width: 768px) {
        display: none;
    }
`;

export const NavItem = styled.div`
      display: flex;
    align-items: center;
    justify-content: center; 
    list-style: none;
    height: 100%; 
     padding: 20px;
    flex-grow: 1;

    @media screen and (max-width: 768px) {
        display: none;
    }
`;

    



export const NavLinks = styled(LinkS)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    height: 100%;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &.active {
        border-bottom: 3px solid #8BC34A;
    }

    &:hover {
        color: #8BC34A;
    }

`
export const NavBtn = styled.nav`
    display: flex;
    align-items: center;
    @media screen and (max-width: 768px) {
        display: none;
    }

`
export const NavBtnAvatar = styled.nav`
    display: flex;
    align-items: center;
    justify-content: flex-end; /* Aligns NavBtnAvatar to the end */
   marginleft: auto;
    
    @media screen and (max-width: 768px) {
        justify-content: flex-end; /* Keeps NavBtnAvatar at the end on small screens */
    }
`;

export const NavBtnLink = styled(LinkR)`
    border-radius: 50px;
    text-decoration: none;
    background: #8BC34A;
    white-space: nowrap;
    padding: 8px 22px;
    color: white;
    font-size: 1rem;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    font-weight: 900;
    margin-left: auto;

    &:hover {
        transition: all 0.2s ease-in-out;
        background: #fff;
        color: #8BC34A;
    }

`
export const NavRight = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  @media screen and (max-width: 768px) {
    display: flex; /* Ensure it's visible on small screens */
    justify-content: flex-start;
  }
`;

export const NavNotification = styled.div`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  justify-content: center;
  margin: 0 30px;

  @media screen and (max-width: 768px) {
    display: flex; /* Ensure notifications are displayed */
    padding: 20px;
    margin-top: 10px;
    justify-content: flex-start;
    width: 100%; 
    box-sizing: border-box; 
    position: relative; 
  }

 @media screen and (max-width: 300px) {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 10px;
  padding: 5px;
  font-size: 12px;
  width: auto; 
  box-sizing: border-box;
  justify-content: center;
}

`;
